import React, { useMemo } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';


interface Props {
    value: boolean | null;
    setValue: React.Dispatch<React.SetStateAction<boolean | null>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

export default function PresenceSituationDropdown({ value, setValue, zIndex, labelStyle, viewStyle }: Props) {
    const items = useMemo(() => [
        { label: 'theAgentShowedUp', value: true },
        { label: 'theAgentDidNotShowedUp', value: false },
    ].map(item => {
        return { label: translate(item.label), value: item.value };
    }), []);

    return (
        <FilterDropdown
            label={translate('presenceSituation')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
